import { Breadcrumb, Container } from "reactstrap"
import UserDetailCard from "../users/UserDetailCard"
import Breadcrumbs from "../../coreComponents/breadcrumbs"
import FarmsSection from "../users/FarmsSection"
import { useLocation } from "react-router-dom"
import UserInstrument from "../users/UserInstrument"
const Dashboard = () => {

  const location = useLocation();
  const userId = location.state?.userId;   // e.g. "42"


  return (
    
    <div className=" container-fluid">
        <Breadcrumbs mainTitle="Users Dashboard" parent="Users" />
         <UserDetailCard userId={userId} />
         <FarmsSection userId={userId}/>
         <UserInstrument userId={userId}/>
    </div>
  )
}

export default Dashboard